import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import Login from "./pages/Login";
import AppLauncher from "./pages/AppLauncher";

// Ingroove pages
import ProductLayout from "./components/layout/ProductLayout";
import Overview from "./pages/ingroove/Overview";
import Users from "./pages/ingroove/Users";
import Hubs from "./pages/ingroove/Hubs";
import HubPartners from "./pages/ingroove/HubPartners";
import Events from "./pages/ingroove/Events";
import ChatRooms from "./pages/ingroove/ChatRooms";
import Payouts from "./pages/ingroove/Payouts";
import Financials from "./pages/ingroove/Financials";
import SystemWallet from "./pages/ingroove/SystemWallet";
import UserDetail from "./pages/ingroove/UserDetail";
import HubDetail from "./pages/ingroove/Hubdetail ";
import EventDetail from "./pages/ingroove/EventDetail";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            {/* App launcher */}
            <Route path="/" element={<AppLauncher />} />

            {/* Ingroove admin */}
            <Route path="/ingroove" element={<ProductLayout product="ingroove" />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<Overview />} />
              <Route path="users" element={<Users />} />
              <Route path="users/:id" element={<UserDetail />} />
              <Route path="hubs" element={<Hubs />} />
              <Route path="hubs/:id" element={<HubDetail />} />
              <Route path="hub-partners" element={<HubPartners />} />
              <Route path="events" element={<Events />} />
              <Route path="events/:id" element={<EventDetail />} />
              <Route path="chat-rooms" element={<ChatRooms />} />
              <Route path="payouts" element={<Payouts />} />
              <Route path="financials" element={<Financials />} />
              <Route path="system-wallet" element={<SystemWallet />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

// npm run build
// firebase deploy
